export default __webpack_public_path__ + "static/media/CircleBadgePlus50.5d4d0e3e.svg";